import { useTranslation } from "react-i18next";
import { ReactComponent as TopRightIcon } from "@assets/images/top-right.svg";
import BaseContainer from "@components/ui/BaseContainer";
import clsx from "clsx";

import classes from "./Vacancies.module.scss";

function Vacancies() {
  const { t } = useTranslation();

  const jobs = t("job.vacancies.list", { returnObjects: true });

  return (
    <BaseContainer className={classes.vacancies}>
      <h3 className={classes.vacancies__title}>{t("job.vacancies.title")}</h3>
      <div className={clsx(classes.vacancies__job, classes.job)}>
        <h2 className={classes.job__title}>{t("job.vacancies.subtitle")}</h2>
        <ul className={clsx(classes.job__list, classes.list)}>
          {jobs.map((job, index) => (
            <li className={clsx(classes.list__item, classes.item)} key={job.title + index}>
              <a className={classes.item__link} href={job.link} target="_blank" rel="noreferrer">
                <h3 className={classes.item__title}>{job.title}</h3>
                <div className={classes.item__imgs}>
                  {job.imgs.map((img) => (
                    <img src={require(`@assets/images/hirings/${img}.svg`)} alt={img} />
                  ))}
                </div>
                <TopRightIcon className={classes.item__arrow} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </BaseContainer>
  );
}

export default Vacancies;
